import { enterpriseService } from "../../../../../services/enterprise.service"
import { workFrontService } from "../../../../../services/work-front.service"
import { DialogWorkFront } from "../../../../../tools/dialog"
import { EventHub } from "../../../../../constants/constants"
import { mapActions } from "vuex"
import { clone } from 'ramda'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'AgroTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // frentes de trabajo
        harvestFronts: [],
        loadingHarvestFronts: false,
        // model para el formulario
        isValidForm: false,
        isCaneEquipmentType: false,
        isStoreroomType: false,
        storeroomName: '',
        enterprises: []
    }),
    computed: {
    },
    created () {
        // Evento lanzado por el diálogo de creación de frentes de trabajo, cuando se guarda el nuevo frente
        this.$eventBus.$on(EventHub.COMMIT_WORK_FRONT, (workFrontDto) => {
            this.getWorkFronts(this.model.enterpriseIdSelected, workFrontDto._id)
        })
    },
    beforeDestroy() {
        // desuscripción al bus de eventos
        this.$eventBus.$off(EventHub.COMMIT_WORK_FRONT)
    },
    mounted () {
        this.getEnterprises()
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread'
        ]),
        /**
         * Carga las empresas en el selector
         */
        async getEnterprises () {
            this.enterprises = await enterpriseService.getAllForSelector()
        },
        /**
         * Carga los frentes de trabajo en el selector
         * @param {*} enterpriseId
         */
        async getWorkFronts (enterpriseId, workFrontId) {
            this.loadingHarvestFronts = true
            const workFronts = await workFrontService.getWorkFrontsByEnterpriseId(enterpriseId);
            if (this.isStoreroomType && this.model.harvestFrontId) {
                this.storeroomName = await workFrontService.getStoreroomByWorkfrontId(enterpriseId, this.model.harvestFrontId);
            }
            this.harvestFronts = workFronts?.sort(function sort(a, b) {
                const nameA = a.name.toLowerCase()
                const nameB = b.name.toLowerCase()
                if (nameA < nameB) {
                    return -1
                } else if (nameA > nameB) {
                    return 1
                } else {
                    return 0
                }
            });
            if (workFrontId) {
                this.model.harvestFrontId = workFrontId
            }
            if (this.model.currentHarvestFrontId) {
                if(this.model.currentHarvestFrontId !== this.model.harvestFrontId) {
                    this.storeroomName !== '' ? this.isValidForm = false : this.isValidForm = true;
                } else {
                    this.isValidForm = true;
                }
            } else {
                this.storeroomName !== '' ? this.isValidForm = false : this.isValidForm = true;
            }
            
            this.loadingHarvestFronts = false
        },
        /**
         * 
         */
        setIsCaneEquipmentType (typeKey) {
            if (typeKey != null) {
                this.isCaneEquipmentType = typeKey === 'CANE_EQUIPMENT'
            }
        },
        setIsStoreroomType (typeKey) {
            if (typeKey != null) {
                this.isStoreroomType = typeKey === 'STOREROOM'
            }
        },
        setIsTruckType (typeKey) {
            if (typeKey != null) {
                this.isTruckType = typeKey === 'TRUCK'
            }
        },
        /**
         * Carga el dialogo para crear un frente de trabajo
         */
        openWorkFront() {
            const bread = {
                key: DialogWorkFront,
                disabled: true,
                text: this.$t('workFront.name'),
                model: {
                    enterprises: clone([this.enterprises.find(enterprise => enterprise._id == this.model.enterpriseIdSelected)]),
                    disableEnterpriseSelector: true,
                    enterpriseId: this.model.enterpriseIdSelected,
                }
            }
            this.pushBread(bread)
        },
        /**
         * Cada vez que se modifica la selección del frente de trabajo, se cargan
         */
        harvestFrontsSelectedFunction (newValue) {
            this.model.harvestFrontId = newValue._id ? newValue._id : newValue;
        },
    },
    watch: {
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.agroTabForm) {
                this.$refs.agroTabForm.resetValidation()
            }
        },
        isValidForm(newVal, oldVal){
            if(newVal !== oldVal) {
                if (this.model.currentHarvestFrontId) {
                    if(this.model.currentHarvestFrontId !== this.model.harvestFrontId) {
                        this.storeroomName !== '' ? this.isValidForm = false : this.isValidForm = true;
                    } else {
                        this.isValidForm = true;
                    }
                } else {
                    this.storeroomName !== '' ? this.isValidForm = false : this.isValidForm = true;
                }
                this.$emit('update:validForm', newVal)
            }
        },
        model: {
            deep: true,
            immediate: true,
            async handler(newModel) {
                if (newModel.enterpriseIdSelected) {
                    await this.getWorkFronts(newModel.enterpriseIdSelected)
                }
            }
        },
        'model.typeKeySelected':{
            deep: true,
            immediate: true,
            handler: function (newTypeKeySelected) {
                if (newTypeKeySelected != null) {
                    this.setIsCaneEquipmentType(newTypeKeySelected);
                    this.setIsStoreroomType(newTypeKeySelected);
                    this.setIsTruckType(newTypeKeySelected);
                }
            }
        },
    }
}
